import * as React from 'react';
import { observable, action, computed } from 'mobx';
import { observer } from 'mobx-react';

import { Dropdown, IDropdown, IDropdownOption } from 'office-ui-fabric-react';

import FunctionStore from '@app/Stores/FunctionStore';

import { FunctionModel, PersonFunctionViewModel } from '@app/Models';
import { TextCell } from './TextCell';
import { ViewMode } from './ViewMode';

interface IInlineFunctionDropdownCellProps {
    value: string;
	row: PersonFunctionViewModel;
	fieldKey: string;
    onChange: Function;
    disabled?: boolean;
}

@observer
export class InlineFunctionDropdownCell extends React.Component<IInlineFunctionDropdownCellProps, {}> {
    private _store: InlineFunctionDropdownCellStore;
    
    constructor(props: IInlineFunctionDropdownCellProps) {
        super(props);
        this._store = new InlineFunctionDropdownCellStore(props);
    }

    componentDidUpdate(prevProps: IInlineFunctionDropdownCellProps) {
		if (this.props.row.id !== prevProps.row.id || this.props.row.dateFrom !== prevProps.row.dateFrom || this.props.row.dateTo !== this.props.row.dateTo) {
			this._store.updateProps(this.props);
		}
	}

    render() {
        if (this._store.mode === ViewMode.view) {
            return <TextCell onClick={this._store.toEditMode} value={this._store.value} />;
        } else {
            return (
				<Dropdown
					notifyOnReselect={true}
					options={this._store.functionOptions}
					onChange={this._store.onChange}
					componentRef={this._store.ref}
					onDismiss={this._store.onMouseLeave}
                    selectedKey={this._store.functionId}
                />
            );
        }
    }
}

class InlineFunctionDropdownCellStore {
    @observable value: string;
    @observable mode: string = ViewMode.view;
    @observable _initValue:string;
    @observable functionId:string = this.functionType || '';
	ref: React.RefObject<IDropdown> = React.createRef();
    private _currentProps: IInlineFunctionDropdownCellProps;
    private readonly _entity: string = 'function';
    private _functionStore: FunctionStore;
    
    constructor(props: IInlineFunctionDropdownCellProps) {
        this.updateProps(props);
        this._functionStore = new FunctionStore();
    }

    @action
    toEditMode = () => {
		if (this._currentProps.disabled) return;
        this.mode = ViewMode.edit;
		setTimeout(() => {
			this.ref.current && this.ref.current.focus(true);
		}, 0);
    };

    @action
    onMouseLeave = () => {
        this.mode = ViewMode.view;
    };

    @action
	onChange = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption) => {
        this.mode = ViewMode.view;
		if (option && this.value !== option.text) {
            this.functionId = '' + option.key; // option.key is string|number type
            this.value = option.text;
            const row = this._currentProps.row as unknown as {[key: string]: string};
            row[this._currentProps.fieldKey as string] = this.value;
            this._currentProps.row.functionId = this.functionId;
            this._currentProps.onChange(this._currentProps.row, this._entity);
        }
	};
    
    get functionType(){
        if(this.value){
            const i =  this._functionStore.functionList.findIndex((func: FunctionModel) => {return func.name === this.value;});
            return '' + this._functionStore.functionList[i].id;
        }
    }

    @computed
    get functionOptions() {
	    return this._functionStore.functionList.filter((func: FunctionModel) => func.name.length > 1).map((func: FunctionModel) => { return {key: func.id, text: func.name};});
    }

    @action
	updateProps(props: IInlineFunctionDropdownCellProps) {
		this._initValue = props.value;
		this._currentProps = {...props};
        this.value = props.value;
        this.functionId = this.functionType || '';
	}
}
